import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import * as LucidIcons from 'lucide-react'
import SVG from 'react-inlinesvg'

export const Icons = {
  TRACTOR: 'tractor',
  TRAILER: 'trailer',
  PHONE: 'phone',
}

const iconLookupTable = {
  [Icons.TRACTOR]: () => require('images/kiosk/tractor.svg'),
  [Icons.TRAILER]: () => require('images/kiosk/trailer.svg'),
  [Icons.PHONE]: () => require('images/kiosk/phone.svg'),
}

// tranform name in format arrow-up to ArrowUp (lucide format)
const lucideNameFormat = (name: string): string => {
  if (!name) return ''
  return _.upperFirst(_.camelCase(name))
}

interface IconProps {
  name: string
  size?: number | string
  className?: string
  [key: string]: any
}

export const Icon: React.FC<IconProps> = ({ name, size, className, ...props }) => {
  const localIcon = _.get(iconLookupTable, name)

  if (localIcon) {
    const iconSource = localIcon()
    return (
      <SVG
        src={iconSource}
        width={size}
        height={size}
        className={classNames('kiosk-icon', className)}
        // passthrough props
        {...props}
      />
    )
  }

  // fallback to Lucide icons
  const formattedName = lucideNameFormat(name)
  const LucidIconComponent = LucidIcons[formattedName]

  if (LucidIconComponent) {
    return <LucidIconComponent size={size} className={className} {...props} />
  }

  console.warn(`Icon: Neither a local nor a Lucide icon was found for the name "${name}".`)
  return null
}
